import { Directive, inject, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { SessionService } from '@utils/session.service';

@Directive({
  selector: '[showForPermissions]',
  standalone: true,
})
export class ShowForPermissionsDirective {
  @Input('showForPermissions') allowedPermissions?: string[];

  private sessionService = inject(SessionService);
  private viewContainerRef = inject(ViewContainerRef);
  private templateRef = inject(TemplateRef<any>);

  ngOnInit() {
    return this.sessionService.getRole() === 'SUPERUSER' || (this.allowedPermissions && this.sessionService.existsPermissions(this.allowedPermissions))
      ? this.viewContainerRef.createEmbeddedView(this.templateRef)
      : this.viewContainerRef.clear();
  }
}
